export default "__VITE_ASSET__QmFAiqqM__"